<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <h2>
          {{ displayName }}
          <a class="btn btn-sm" @click="$emit('reset-farm')">(Change farm)</a>
        </h2>

        <div class="form-group">
          <div class="radio">
            <label class="radio-inline">
              <input type="radio" v-model="searchType" value="va" @click="resetData">VA
            </label>
            <label class="radio-inline">
              <input type="radio" v-model="searchType" value="drug" @click="resetData">DRUG
            </label>
          </div>
        </div>

        <div class="panel-body">
          <form v-on:submit.prevent="onSubmit">
            <div class="row">
              <div class="form-group">
                <label for="category">Category</label>
                <select class="form-control" id="category" v-model="category">
                    <option value="NoDCAT">NoDCAT</option>
                    <option value="All">All</option>
                    <option value="All - no Heifers">All - no Heifers</option>
                    <option value="DCAT - no Heifers">DCAT - no Heifers</option>
                    <option value="DCAT - incl Heifers">DCAT - incl Heifers</option>

                </select>
              </div>
            </div>
            <div v-if="!searching">
              <input type="submit" class="btn btn-primary" value="Generate"/>
              <template v-if="hasData">
                | <a :href="exportUrl" target="_blank" class="btn btn-success">Download as PDF</a>
              </template>
            </div>
            <div v-else>
              <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </div>
          </form>
        </div>
      </div>
    </div>

    <br>

    <va-report v-if="searchType == 'va' && hasData" :headers="headers" :groups="groups"></va-report>

    <drug-report v-if="searchType == 'drug' && hasData" :headers="headers" :groups="groups"></drug-report>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { reportService, BACKEND_URL } from '../../../_services'
import VaReport from './VaReport.vue'
import DrugReport from './DrugReport.vue'

export default {
  props: [
    'farmId',
    'displayName',
  ],
  components: {
    VaReport,
    DrugReport,
  },
  data () {
    return {
      searchType: 'va',
      category: 'DCAT',
      headers: {},
      groups: {},
      searching: false,
    }
  },
  computed: {
    hasData: function () {
      return Object.keys(this.headers).length > 0
    },
    exportUrl: function() {
      return `${BACKEND_URL}/reports/${this.searchType}/export_pdf?farm_id=${this.farmId}&category=${this.category}`
    },
  },
  methods: {
    ...mapActions('alert', ['error']),
    onSubmit: function(){
      this.searching = true

      reportService.getReportData(
        this.searchType, this.farmId, this.category
      ).then((data) => {
        this.headers = data.headers[0] || {}
        this.groups = data.groups
        this.searching = false
      }).catch((error) => {
        this.error({message: error.response.data.msg})
        this.searching = false
      })
    },
    resetData: function(){
      this.headers = {}
      this.groups = {}
    },
  },
};
</script>
